import { DeliveryLogType, MessageCategory } from '@dev/ee-api/ee-api-models';

import i18n from '@/../i18n';
export const LogResults = [
    {
        name: 'ignore',
        value: MessageCategory.Ignore,
    },
    {
        name: 'spam',
        value: MessageCategory.Spam,
    },
    {
        name: 'blacklisted',
        value: MessageCategory.BlackListed,
    },
    {
        name: 'nomailbox',
        value: MessageCategory.NoMailbox,
    },
    {
        name: 'greylisted',
        value: MessageCategory.GreyListed,
    },
    {
        name: 'throttled',
        value: MessageCategory.Throttled,
    },
    {
        name: 'timeout',
        value: MessageCategory.Timeout,
    },
    {
        name: 'connectionproblem',
        value: MessageCategory.ConnectionProblem,
    },
    {
        name: 'spfproblem',
        value: MessageCategory.SPFProblem,
    },
    {
        name: 'accountproblem',
        value: MessageCategory.AccountProblem,
    },
    {
        name: 'dnsproblem',
        value: MessageCategory.DNSProblem,
    },
    {
        name: 'notdeliveredcancelled',
        value: MessageCategory.NotDeliveredCancelled,
    },
    {
        name: 'codeerror',
        value: MessageCategory.CodeError,
    },
    {
        name: 'manualcancel',
        value: MessageCategory.ManualCancel,
    },
    {
        name: 'connectionterminated',
        value: MessageCategory.ConnectionTerminated,
    },
    {
        name: 'notdelivered',
        value: MessageCategory.NotDelivered,
    },
    {
        name: 'unknown',
        value: MessageCategory.Unknown,
    },
];

export const DeliveryLogTypeTranslations = {
    [DeliveryLogType.ReadyToSend]: i18n.t('readytosend'),
    [DeliveryLogType.WaitingToRetry]: i18n.t('waitingtoretry'),
    [DeliveryLogType.Sending]: i18n.t('sending'),
    [DeliveryLogType.Error]: i18n.t('bounced'),
    [DeliveryLogType.Sent]: i18n.t('sent'),
    [DeliveryLogType.Opened]: i18n.t('opened'),
    [DeliveryLogType.Clicked]: i18n.t('clicked'),
    [DeliveryLogType.Unsubscribed]: i18n.t('unsubscribed'),
    [DeliveryLogType.AbuseReport]: i18n.t('complained'),
    [DeliveryLogType.Suppressed]: i18n.t('suppressed'),
    [DeliveryLogType.Bounced]: i18n.t('bounced'),
};

export const filterStatusesToDeliveryLogTypees = {
    ReadyToSend: [DeliveryLogType.ReadyToSend],
    WaitingToRetry: [DeliveryLogType.WaitingToRetry],
    Sending: [DeliveryLogType.Sending],
    Sent: [DeliveryLogType.Sent],
    Opened: [DeliveryLogType.Opened],
    Clicked: [DeliveryLogType.Clicked],
    Unsubscribed: [DeliveryLogType.Unsubscribed],
    Bounced: [DeliveryLogType.Error],
    [DeliveryLogType.Error]: ['Bounced'],
    [DeliveryLogType.AbuseReport]: [DeliveryLogType.AbuseReport],
    Suppressed: [DeliveryLogType.Suppressed],
};

export const LogStatusesToDisplay = {
    WaitingToRetry: ['WaitingToRetry'],
    ReadyToSend: ['ReadyToSend'],
    Sending: ['Sending'],
    Sent: ['Sent'],
    Opened: ['Opened'],
    Clicked: ['Clicked'],
    Bounced: ['Error'],
    Unsubscribed: ['Unsubscribed'],
    Suppressed: [DeliveryLogType.Suppressed],
    AbuseReport: ['Complained'],
};

export const MessageCategoryTranslations = {
    [MessageCategory.Unknown]: i18n.t('unknown'),
    [MessageCategory.Ignore]: i18n.t('ignore'),
    [MessageCategory.Spam]: i18n.t('spam'),
    [MessageCategory.BlackListed]: i18n.t('blacklisted'),
    [MessageCategory.NoMailbox]: i18n.t('nomailbox'),
    [MessageCategory.GreyListed]: i18n.t('greylisted'),
    [MessageCategory.Throttled]: i18n.t('throttled'),
    [MessageCategory.Timeout]: i18n.t('timeout'),
    [MessageCategory.ConnectionProblem]: i18n.t('connectionproblem'),
    [MessageCategory.SPFProblem]: i18n.t('spfproblem'),
    [MessageCategory.AccountProblem]: i18n.t('accountproblem'),
    [MessageCategory.DNSProblem]: i18n.t('dnsproblem'),
    [MessageCategory.NotDeliveredCancelled]: i18n.t('notdeliveredcancelled'),
    [MessageCategory.CodeError]: i18n.t('codeerror'),
    [MessageCategory.ManualCancel]: i18n.t('manualcancel'),
    [MessageCategory.ConnectionTerminated]: i18n.t('connectionterminated'),
    [MessageCategory.NotDelivered]: i18n.t('notdelivered'),
};
